<template>
  <div class="video-review">
    <section class="review-publish" v-if="commentFlag">
      <header>
        <div class="header-please">{{ $t('customer.pleaseReview') }}</div>
        <div class="header-star">
          <div class="star-text" v-show="params.score">{{ params.score * 2 + $t('homepage.marks') }} </div>
          <el-rate :allow-half="true" v-model="params.score" void-color="#a0bada"
            void-icon-class="el-icon-star-on"></el-rate>
        </div>
      </header>
      <div class="publish-content">
        <textarea class="content-input" v-model="params.content" :maxlength="140"
          :placeholder="$t('homepage.profileHolder')"></textarea>
        <div class="content-hint">{{ params.content.length }}/140</div>
      </div>
      <div class="publish-control">
        <div class="control-screenshots"><el-checkbox v-model="isScreenShots" v-if="false">{{ $t('homepage.cutImage')
        }}</el-checkbox></div>
        <div class="control-publish" @click="postReview">{{ $t('customer.publish') }}</div>
      </div>
    </section>
    <section class="review-list">
      <header>
        <div class="list-title">
          {{ $t('customer.reviewArea') }}
        </div>
        <div class="list-order" @click="changeOrderType">
          {{ $t('homepage.time') }}
          <i class="el-icon-sort-down" :class="{ isActive: orderType === 'time_down' }"></i>
          <i class="el-icon-sort-up" :class="{ isActive: orderType === 'time_up' }"></i>
        </div>
      </header>
      <div class="list-content-review">
        <div class="content-item" v-for="item in commentListData" :key="item.id">
          <div class="item-content">
            <div class="item-avatar">
              <img :src="item.avatar_path" alt="head">
            </div>
            <div class="item-data">
              <div class="data-user">{{ item.username }}
                <el-rate disabled class="star" :value="item.score / 2" void-color="#a0bada"
                  void-icon-class="el-icon-star-on"></el-rate>
              </div>
              <div class="data-review">{{ item.content }}</div>
            </div>
          </div>
          <dir class="item-date">
            <div class="date-date">{{ item.create_time.split(' ')[0] }}</div>
            <div class="date-controls">
              <el-tooltip class="item" effect="dark" :content="$t('homepage.edit')" placement="bottom">
                <i class="el-icon-edit-outline" v-if="isShowEdit(item.userid)" @click="editComment(item.id)"></i>
              </el-tooltip>

              <el-tooltip class="item" effect="dark" :content="$t('homepage.delete')" placement="bottom">
                <i class="el-icon-delete-solid" @click="delComment(item.id)" v-if="isShowDel(item.userid)"></i>
              </el-tooltip>

            </div>
          </dir>
        </div>
        <div class="placeholder" v-if="commentListData.length === 0">{{ $t('global.noData') }}</div>
      </div>
    </section>
    <el-pagination v-if="commentListData.length > 0" class="msg-pagination-container" background
      layout="prev, pager, next" :total="total_number" :page-size="page_size" :current-page="page_index"
      @current-change="handleCurrentChange">
    </el-pagination>
  </div>
</template>

<script>
export default {
  props: {
    videoData: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {
      commentId: null, // 记录被编辑的评论id
      commentFlag: true, //控制是否显示评论输入框

      orderType: "time_down",
      isScreenShots: false, // 原型中并无截图相关功能，暂不开发

      params: {
        score: 5,
        content: "",
      },

      page_size: 10,
      page_index: 1,
      total_number: 0,

      commentListData: [],
    };
  },
  watch: {
    commentListData(nv) {
      this.$emit("changeCount", nv.length);
    },
    videoData(val){
      if(val){
        this.getCommentFlag();
      }
    }
  },
  created() {
  },
  methods: {
    handleCurrentChange(val) {
      this.page_index = val;
      this.getCommentFlag();
    },
    editComment(id) {
      this.commentId = id;
      this.commentFlag = true;
    },
    getCommentFlag() {
      let success = (res) => {
        this.commentFlag = Object.keys(res.data.mark_comment).length === 0;
        let randomNum = Math.floor(Math.random() * 5) + 1;
        this.commentListData = [];
        if (!this.commentFlag) {
          this.commentListData.unshift({
            id: res.data.mark_comment.id,
            userid: this.$g.user_id,
            avatar_path: require(`@/assets/images/customer/head${randomNum}.png`),
            username: this.$t("customer.me"),
            content: res.data.mark_comment.content,
            create_time: res.data.mark_comment.create_time,
            score: res.data.mark_comment.score,
          });
        }
        this.getCommentList();
      };
      this.$ajax({
        url: "api/video/video",
        method: "get",
        params: {
          videoid: this.videoData.id,
          userid: this.$g.user_id,
          cutid: this.cutid,
        },
        func: {
          success,
        },
      });
    },
    delComment(id) {
      this.$confirm(
        this.$t("homepage.delCommentsWhat") + "?",
        this.$t("global.tips"),
        {
          confirmButtonText: this.$t("global.sure"),
          cancelButtonText: this.$t("global.cancel"),
          type: "warning",
        }
      )
        .then(() => {
          let success = (res) => {
            this.$message.success(this.$t("homepage.delSuccess"));
            this.commentId = null;
            this.params.score = 5;
            this.params.content = "";
            this.getCommentFlag();
            this.$emit('refresh')
          };
          this.$ajax({
            url: "api/comment/comment",
            method: "delete",
            params: {
              id,
            },
            func: {
              success,
            },
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: this.$t("homepage.notDel"),
          });
        });
    },
    postReview() {
      if (this.$g.user_id == 0) {
        this.$message.warning(this.$t("homepage.needLogin"));
        return;
      }
      if (this.params.content == "" || this.params.content.trim().length == 0) {
        this.$message.warning(this.$t("homepage.addComments"));
        return;
      }

      let method, data;
      if (this.commentId != null) {
        method = "put";
        data = {
          id: this.commentId,
          user_id: this.$g.user_id,
          res_id: this.videoData.id,
          origin: 0,
          score: this.params.score * 2,
          content: this.params.content,
          image_path: this.screenshotUrl,
        };
      } else {
        method = "post";
        data = {
          user_id: this.$g.user_id,
          res_id: this.videoData.id,
          origin: 0,
          score: this.params.score * 2,
          image_path: this.screenshotUrl,
          content: this.params.content,
        };
      }

      let success = (res) => {
        this.$message.success(this.$t("customer.pubSuc"));
        this.getCommentFlag();
        this.$emit('refresh')
      };
      this.$ajax({
        url: "api/comment/comment",
        method,
        data,
        func: {
          success,
        },
      });
    },
    changeOrderType() {
      this.orderType === "time_down"
        ? (this.orderType = "time_up")
        : (this.orderType = "time_down");
      this.getCommentList();
    },
    getCommentList() {
      let success = (res) => {
        this.total_number = parseInt(res.data.data_sum);
        this.page_index = parseInt(res.data.page_index);
        this.commentListData = res.data.data;
        this.commentListData.forEach((item) => {
          if (!item.avatar_path.includes("http")) {
            item.avatar_path = this.BASE_URL + item.avatar_path;
          }
        });
        // this.total_number = res.data.data_sum;
        // let result = res.data.data;
        // let newResult = [];
        // result.forEach((item, index) => {
        //   // 获取本地随机头像
        //   if (item.userid === this.userInfo.id) {
        //     return;
        //   } else {
        //     var randomNum = Math.floor(Math.random() * 5) + 1;
        //     item.avatar_path = require(`@/assets/images/customer/head${randomNum}.png`);
        //     item.create_time = item.create_time.toString();
        //     newResult.push(item);
        //   }
        // });
        // this.commentListData = [...this.commentListData, ...newResult];
      };
      this.$ajax({
        url: "api/video/video_comment_list",
        method: "get",
        params: {
          page_index: this.page_index,
          page_size: this.page_size,
          res_id: this.videoData.id,
          order_type: this.orderType,
        },
        func: {
          success: success,
        },
      });
    },
    isShowDel(commentatorId) {
      let user_id = this.$g.user_id;
      if (user_id === commentatorId) {
        return true;
      }
      let manage = sessionStorage.getItem("manage");
      if (typeof manage != "undefined" && manage != null && manage != "") {
        return true;
      } else {
        return false;
      }
    },
    isShowEdit(commentatorId) {
      let user_id = this.$g.user_id;
      if (user_id === commentatorId) {
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>

<style scoped lang='scss'>
.video-review {
  .review-publish {
    header {
      margin-top: 2rem;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .header-please {
        font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
        font-size: 1.2rem;
        font-weight: 700;
      }

      .header-star {
        display: flex;
        justify-content: right;
        align-items: center;
        font-size: 1.2rem;
        color: #ffa947;

        .star-text {
          position: relative;
          top: 2px;
          margin-right: 1.5rem;
        }

        :deep(.el-rate__icon) {
          font-size: 2rem;
        }
      }
    }

    .publish-content {
      margin-top: 1.5rem;
      position: relative;

      .content-input {
        height: 6rem;
        width: 97%;
        border: 1px solid #efefef;
        padding: 0.6rem 1rem;
        font-family: "微软雅黑", sans-serif;
      }

      .content-hint {
        position: absolute;
        right: 1.6rem;
        bottom: 0.8rem;
        overflow: hidden;
        background: #fff;
      }
    }

    .publish-control {
      margin-top: 1rem;
      display: flex;
      justify-content: space-between;

      .control-screenshots {
        :deep(.is-focus) {
          .el-checkbox__inner {
            border: 1px solid #dcdfe6;
          }
        }

        :deep(.is-checked) {
          .el-checkbox__inner {
            background: #e62125;
            border: 1px solid #dcdfe6;
          }

          .el-checkbox__label {
            color: #e62125;
          }
        }

        :deep(.el-checkbox__inner ){
          // border: ;
          &:hover {
            border: #e62125 solid 1px;
          }
        }
      }

      .control-publish {
        background-color: #2c2e3f;
        padding: 0.8rem 1.6rem;
        color: #fff;
        margin-right: 0.6rem;

        &:hover {
          cursor: pointer;
          opacity: 0.9;
        }
      }
    }
  }

  .review-list {
    margin-top: 1rem;
    margin-bottom: 1rem;

    header {
      user-select: none;
      display: flex;
      padding-bottom: 1rem;
      border-bottom: #efefef 1px solid;

      .list-title {
        font-size: 1.2rem;
        font-weight: 700;
        margin-right: 2rem;
      }

      .list-order {
        cursor: pointer;

        .isActive {
          color: #e62125;
        }

        &:hover {
          opacity: 0.8;
        }
      }
    }

    .list-content-review {
      margin-top: 2.5rem;

      .placeholder {
        height: 11rem;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #999;
      }

      .content-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: #efefef solid 1px;

        &:hover {
          .item-date {
            padding: 0;

            .date-date {
              display: none;
            }

            .date-controls {
              display: block;
              font-size: 1.5rem;

              >i {
                margin-right: 1rem;
              }

              >i:hover {
                cursor: pointer;
                opacity: 0.7;
              }
            }
          }
        }

        .item-content {
          display: flex;
          justify-content: left;
          padding: 2.5rem 1rem;
          width: 85%;

          .item-avatar {
            width: 40px;
            height: 40px;
            border-radius: 40px;
            overflow: hidden;

            img {
              width: 40px;
              height: 40px;
            }
          }

          .item-data {
            margin-left: 2rem;
            max-width: 90%;
            overflow: hidden;
            white-space: warp;

            .data-user {
              display: flex;
              align-items: center;
              font-size: 1.2rem;
              color: #999999;

              .star {
                margin-left: 1rem;
              }
            }

            .data-review {
              word-wrap: break-word;
              margin-top: 1rem;
              line-height: 1.4rem;
            }
          }
        }

        .item-date {
          padding: 0;
          width: 20%;
          text-align: right;
          color: #999999;

          .data-date {
            width: 100%;
          }

          .date-controls {
            display: none;
            font-size: 1.5rem;

            >i {
              margin-right: 1rem;
            }

            >i:hover {
              cursor: pointer;
              opacity: 0.7;
            }
          }
        }
      }
    }
  }

  .msg-pagination-container {
    margin-top: 2rem;
    margin-bottom: 4rem;
  }

  :deep(.msg-pagination-container.is-background .el-pager li ){
    // 对页数的样式进行修改
    &:hover {
      background-color: #e62125;
      opacity: 0.7;
      color: #fff;
    }
  }

  :deep(.msg-pagination-container.is-background .btn-next) {
    // 对下一页的按钮样式进行修改
    &:hover {
      background-color: #e62125;
      opacity: 0.7;
      color: #fff;
    }
  }

  :deep(.msg-pagination-container.is-background .btn-prev ){
    // 对上一页的按钮样式进行修改
    &:hover {
      background-color: #e62125;
      opacity: 0.7;
      color: #fff;
    }
  }

  :deep(.msg-pagination-container.is-background .el-pager li:not(.disabled).active) {
    //当前选中页数的样式进行修改
    background-color: #e62125;
    color: #fff;
  }
}
</style>
